export default "__VITE_ASSET__DQQgX1aZ__"